import { PostQrCode } from "@package/ui-apollo-components";
import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { useSelectorWall } from "@package/ui-redux";
import { useWallAnalytics, useWallProvider } from "@package/ui-wall";
import { useTriviaContext } from "../context-trivia";
import { TriviaButton } from "../TriviaButton/TriviaButton";
import { TriviaResulChart } from "./TriviaResultChart";

export function TriviaResult() {
  const { screen } = useTriviaContext();
  const { trigger } = useWallAnalytics();
  const provider = useWallProvider();
  const location = useSelectorWall((state) => state.wall.location);
  const profile = useSelectorWall((state) => state.wall.profile);

  return (
    <div className="flex flex-col h-full w-full">
      <div className="h-3/4 w-full justify-center items-center">
        <div className="flex flex-col h-full w-full justify-center items-center">
          <div className="flex flex-col h-3/5 w-full justify-center items-center">
            <TriviaResulChart />
          </div>
          <div className="flex flex-col h-2/5 w-full justify-center items-center">
            <div
              className="p-4 rounded-3xl bg-black/75 text-white"
              style={{ inlineSize: "min-content" }}
            >
              <PostQrCode
                location={location}
                profile={profile}
                post={screen?.flyout?.post}
                size={256}
              />
              <div className="text-4xl pt-4 font-bold text-center text-white">
                {screen?.flyout?.post?.qrCodeText ?? "SCAN FOR DETAILS"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex h-1/4 justify-center items-center px-20">
        <TriviaButton
          text="Close"
          onHandleMouse={(x, y) => {
            if (screen) {
              provider?.onFlyoutClosed(screen.id);
              trigger(
                EventPayloadType.PostClosed,
                {
                  position: {
                    x,
                    y,
                  },
                  screen: screen.index,
                },
                screen.flyout?.post?.id ?? undefined,
                screen.layout?.id ?? undefined,
              );
            }
          }}
        />
      </div>
    </div>
  );
}
